import { render, staticRenderFns } from "./DashboardV3.vue?vue&type=template&id=16e801ab&"
import script from "./DashboardV3.vue?vue&type=script&lang=js&"
export * from "./DashboardV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports